import { render, staticRenderFns } from "./get-free-vpn.vue?vue&type=template&id=b682a9be&scoped=true"
import script from "./get-free-vpn.vue?vue&type=script&lang=js"
export * from "./get-free-vpn.vue?vue&type=script&lang=js"
import style0 from "./get-free-vpn.vue?vue&type=style&index=0&id=b682a9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b682a9be",
  null
  
)

export default component.exports